var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Wishlist = (function (Wishlist) {

        Wishlist.Messages = (function (Messages) {

            Messages.Add = function (id, skuId, path, qty, extraAttributes, bundleItems, listId, currentListId) {
                var data = {
                    id: id,
                    skuId: skuId,
                    path: path,
                    qty: qty || 1,
                    extraAttributes: extraAttributes, //example: extraAttributes: [{code:'test',value:'testValue'}]
                    bundleItems: bundleItems, //example: bundleItems: [{parentProductId:'testValue', productId:'testValue', quantity: 'testValue'}]
                    listId: listId || 0,
                    currentListId: currentListId || 0 // if previousListId is passed then the product will be removed 
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.Add", data);
            };
            Messages.Add.className = "Vendd.Wishlist.Messages.Add";

            Messages.AddSuccess = function (productId, skuId, response) {
                response.data = JSON.parse(response.data);
                response.productId = productId;
                response.skuId = skuId;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Wishlist.Messages.AddSuccess', response);
            };
            Messages.AddSuccess.className = 'Vendd.Wishlist.Messages.AddSuccess';

            Messages.MultipleAdd = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Wishlist.Messages.MultipleAdd', data);
            };
            Messages.MultipleAdd.className = 'Vendd.Wishlist.Messages.MultipleAdd';

            Messages.MultipleAddSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.MultipleAddSuccess", data);
            };
            Messages.MultipleAddSuccess.className = 'Vendd.Wishlist.Messages.MultipleAddSuccess'

            Messages.Remove = function (id) {
                var data = {
                    id: id
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.Remove", data);
            };
            Messages.Remove.className = "Vendd.Wishlist.Messages.Remove";

            Messages.RemoveSuccess = function (productId, skuId, response) {
                response.data = JSON.parse(response.data);
                response.productId = productId;
                response.skuId = skuId;
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Wishlist.Messages.RemoveSuccess', response);
            };
            Messages.RemoveSuccess.className = 'Vendd.Wishlist.Messages.RemoveSuccess';

            Messages.MoveAllToCart = function () {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.MoveAllToCart");
            };
            Messages.MoveAllToCart.className = "Vendd.Wishlist.Messages.MoveAllToCart";

            Messages.MoveToCart = function (id, productId, skuId) {
                var data = {
                    id: id,
                    productId: productId,
                    skuId: skuId
                };

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.MoveToCart", data);
            };
            Messages.MoveToCart.className = "Vendd.Wishlist.Messages.MoveToCart";

            Messages.UpdateItemQuantity = function (itemId, quantity) {
                var data = {
                    itemId: itemId,
                    quantity: quantity
                };

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.UpdateItemQuantity", data);
            };
            Messages.UpdateItemQuantity.className = "Vendd.Wishlist.Messages.UpdateItemQuantity";

            Messages.Clear = function () {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.Clear");
            };
            Messages.Clear.className = "Vendd.Wishlist.Messages.Clear";

            Messages.ClearSuccess = function () {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Wishlist.Messages.ClearSuccess");
            };
            Messages.ClearSuccess.className = "Vendd.Wishlist.Messages.ClearSuccess";

            Messages.Changed = function (model) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Wishlist.Messages.Changed', model);
            };
            Messages.Changed.className = 'Vendd.Wishlist.Messages.Changed';

            Messages.GetModel = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Wishlist.Messages.GetModel');
            };
            Messages.GetModel.className = 'Vendd.Wishlist.Messages.GetModel';

            Messages.Warning = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Wishlist.Messages.Warning', response);
            };
            Messages.Warning.className = 'Vendd.Wishlist.Messages.Warning';

            Messages.Failed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Wishlist.Messages.Failed', response);
            };
            Messages.Failed.className = 'Vendd.Wishlist.Messages.Failed';

            return Messages;

        })(Wishlist.Messages || {});

        return Wishlist;

    })(Vendd.Wishlist || {});


    return Vendd;

})(Vendd || {});